<template>
  <v-app>
      
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >
              <v-card class="elevation-1">
                <v-card-text>
                  <v-form ref="login_form" v-on:submit.prevent="login">
                    <v-text-field
                      label="Usuario"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="username"
                      :rules="requiredRules"
                    ></v-text-field>
                    <v-text-field
                      label="Contraseña"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="password"
                      :rules="requiredRules"
                    ></v-text-field>
                    <p class="caption" v-if="loginError">{{errorMessage}}</p>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text large @click="login">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <Loader :showLoader="showLoader" />
        </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'
import Logo from '../components/Logo'
import Loader from '../components/Loader'

export default {
    name: 'Login',
    components: {
        Logo,
        Loader
    },
    data() {
        return {
            username: '',
            password: '',
            requiredRules: [
                value => !!value || 'Campo obligatorio'
            ],
            loginError: false,
            errorMessage: 'Usuario/Contraseña incorrectos.',
            showLoader: false
        }
    },
    methods: {
        login() {
            this.showLoader = true
            if(this.$refs.login_form.validate()) {
                this.loginError = false
                axios.post(this.$store.state.astilleroURL + '/api/user/login', {
                    username: this.username,
                    password: this.password
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => {
                    //console.log(res.data)
                    this.showLoader = false
                    this.$store.state.user = res.data
                    this.$store.state.token = res.data.token
                    this.$store.state.isLogin = true
                    localStorage.setItem('monaUser', JSON.stringify(res.data))
                    localStorage.setItem('monaToken', res.data.token)
                    this.$router.push('/dashboard').catch((error) => {})
                    //console.log(JSON.parse(localStorage.getItem("user")))
                })
                .catch(error => {
                    this.loginError = true
                    this.showLoader = false
                    console.log(error)
                })
            }
        }
    }
}
</script>

<style>

</style>